import cls from "./styles.module.css";

type TProps = {
  title: string;
};
export default function PostTitle(props: TProps) {
  return <h1 className={cls.root}>{props.title}</h1>;
}
